<script>
import DefaultMixin from "@/components/leiloes/mixin"
import RelatorioCell from '@/components/leiloes/components/relatorios/includes/RelatorioCell'
import {listRelatoriosDinamicos, download, relatorio} from "@/domain/relatorios/services"
import ERow from "@/components/layout/components/Row"
import ECol from "@/components/layout/components/Col"
import {ErpSelect, ErpSField} from 'uloc-vue-plugin-erp'
import {donwloadFile} from "@/utils/downloadFile";
import createPrint from "@/components/relatorios/components/customPrint/createPrint"
import analiseBensSemArquivoWindow from "@/components/relatorios/components/bens/analiseBensSemArquivoWindow";

export default {
  name: 'Dashboard',
  inject: ['page', 'erplayout'],
  mixins: [DefaultMixin],
  components: {
    ECol,
    ERow,
    RelatorioCell,
    ErpSelect,
    ErpSField
  },
  data() {
    return {
      leilao: this.page.leilao,
      loadingRD: false,
      gerandoRelatorio: false,
      relatorioDinamico: null,
      relatorios: [],
      idRelatorioParaGerar: null,
      relatoriosGerenciaisFiltros: {
        id: this.page.leilao.id
      }
    }
  },
  computed: {},
  mounted() {
    this.page.setActive('relatorios')
    this.relatoriosDinamicos()
    // document.querySelector('.u-erp-layout-container').classList.add('leilao-telao-seletor')
  },
  destroyed() {
    // document.querySelector('.u-erp-layout-container').classList.remove('leilao-telao-seletor')
  },
  methods: {
    createPrint: createPrint,
    actionPrint (action) {
      this.gerar(action)
    },
    gerar(formato = 'html') { // Para relatórios gerenciais
      let filters = this.relatoriosGerenciaisFiltros
      this.$uloc.loading.show()
      relatorio(this.idRelatorioParaGerar, filters, formato)
          .then(response => {
            this.$uloc.loading.hide()
            formato === 'html' && this.createPrint(response.data, () => import('@/components/relatorios/components/customPrint/DefaultPrint'), 'leilao', 'Relatórios de Leilão', 'landscape')
          })
          .catch(error => {
            this.$uloc.loading.hide()
            if (formato === 'html') {
              this.alertApiError(error)
            } else{
              error.data.text().then(text => {
                this.alertApiError({data: JSON.parse(text)})
              })
            }
          })
    },
    gerarId (id, filtros = null) {
      this.idRelatorioParaGerar = id
      if (filtros) {
        this.relatoriosGerenciaisFiltros = filtros
      } else {
        this.relatoriosGerenciaisFiltros = {id: this.leilao.id}
      }
      this.gerar()
    },
    relatoriosDinamicos() {
      this.loadingRD = true
      listRelatoriosDinamicos('leilao')
          .then(({data}) => {
            this.loadingRD = false
            this.relatorios = data.result.slice().map(r => {
              return {
                label: r.nome,
                value: r.id
              }
            })
            console.log(data)
          })
          .catch(error => {
            this.loadingRD = false
            this.alertApiError(error)
          })
    },
    gerarRelatorioDinamico() {
      console.log('Gerando ' + this.relatorioDinamico)
      this.gerandoRelatorio = true
      download(this.relatorioDinamico, {leilao: this.leilao.id})
          .then(response => {
            this.gerandoRelatorio = false
            donwloadFile(response)
          })
          .catch(error => {
            this.gerandoRelatorio = false
            this.alertApiError(error)
          })
    },
    open (url) {
      if (this.$globalConfig && this.$globalConfig['sistema.ux.relatorio-nova-janela'] && this.$globalConfig['sistema.ux.relatorio-nova-janela'].value && Number(this.$globalConfig['sistema.ux.relatorio-nova-janela'].value) === 1) {
        let route = this.$router.resolve(url)
        window.open(route.href, '_blank')
        return
      }
      this.$router.push(url)
    },
    exportarLotes () {
      this.relatorioGeral('lotes')
    },
    relatorioGeral (id) {
      relatorio(id, {id: this.leilao.id})
          .then(response => {
            this.loading = false
            // donwloadFile(response)
          })
          .catch(error => {
            this.loading = false
            error.data.text().then(text => {
              this.alertApiError({data: JSON.parse(text)})
            })
            console.log(error)
          })
    },
    relatorioPagamentos () {
      this.gerarId('analisePagamentoLeilao', {
        id: this.leilao.id,
        tipo: 'todos'
      })
    },
    analiseBensSemArquivoWindow: analiseBensSemArquivoWindow
  },
  meta: {
    title: 'Relatórios do Leilão',
    name: 'Relatórios do Leilão'
  }
}
</script>

<template>
  <div class="leilao-relatorios-page">
    <div class="relatorios-leilao-container">

      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.resumo'})" title="Resumo do leilão"
                      icon="chart-pie" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.saida'})" title="Saídas/Vendas"
                      icon="chart-line" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.saida.arrematante'})"
                      title="Saídas/Vendas Unificado" icon="chart-line" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.lances'})" title="Lances" icon="chart-bar"
                      icon-type="fa" icon-style="light"/>
      <!--      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.lances.comitente'})" title="Lances por Comitente" icon="user-chart" icon-type="fa" icon-style="light" />-->
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.lotes.retirados'})" title="Lotes Retirados"
                      icon="arrow-right" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.lotes.vendidos'})" title="Lotes Vendidos"
                      icon="gavel" icon-type="fa" icon-style="light" class-style="lotesVendidos"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.lotes.condicional'})"
                      title="Lotes Condicional" icon="gavel" icon-type="fa" icon-style="light"
                      class-style="lotesCondicional"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.lotes.nao.vendidos'})"
                      title="Lotes Não Vendidos" icon="gavel" icon-type="fa" icon-style="light"
                      class-style="lotesNaoVendidos"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.diario.leilao'})" title="Diário de Leilão"
                      icon="file-alt" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.numeros.visitas'})"
                      title="Números Visitas por Lotes" icon="eye" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.certidao.publicacao'})"
                      title="Certidão de Publicação" icon="file-alt" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.termo.alienacao'})"
                      title="Termo de Alienação" icon="file-alt" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.arrematacao.leilao'})"
                      title="Auto Positivo de Arrematação" icon="file-alt" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.arrematacao.auto2'})"
                      title="Auto de Arrematação (Mod2)" icon="file-alt" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="open({name: 'leiloes.relatorios.certidao.negativa'})"
                      title="Certidão Negativa" icon="file-alt" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="exportarLotes"
                      title="Exportar Lotes" icon="file-spreadsheet" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="relatorioGeral('lances')"
                      title="Exportar Lances" icon="file-spreadsheet" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="relatorioPagamentos"
                      title="Pagamentos Efetuados" icon="money-check-alt" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="gerarId('analisePagamentoMaiorLeilao')"
                      title="Pagamentos Efetuados Maior que Devido" icon="funnel-dollar" icon-type="fa" icon-style="light"/>

      <relatorio-cell @click.native="gerarId('ata')" title="Veículos - Ata de Realização de Leilão" icon="car" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="gerarId('veiculosConfirmacaoDadosLeilao')" title="Veículos - Confirmação de Dados" icon="car" icon-type="fa" icon-style="light"/>
      <relatorio-cell @click.native="gerarId('relacaoPatioLeilao')" title="Veículos - Relação para Pátio" icon="car" icon-type="fa" icon-style="light"/>

      <relatorio-cell @click.native="analiseBensSemArquivoWindow" title="Analisar Ausência de Arquivos/Fotos dos Lotes" icon="car" icon-type="fa" icon-style="light"/>

      <router-view/>

    </div>

    <e-row>
      <e-col class="wrapper">
        <erp-s-field
            view="tl"
            label="Mais relatórios:"
        >
          <erp-select placeholder="Selecione"
                      size="2"
                      :options="relatorios"
                      v-model="relatorioDinamico"/>
        </erp-s-field>
        <e-btn :loading="gerandoRelatorio" @click="gerarRelatorioDinamico" label="Gerar" class="m-t-xs"/>
      </e-col>
    </e-row>
  </div>
</template>

<style src="../relatorios/assets/global.styl" lang="stylus"/>
